import { render } from "./modelo01.vue?vue&type=template&id=19eb88d0&scoped=true"
import script from "./modelo01.vue?vue&type=script&lang=js"
export * from "./modelo01.vue?vue&type=script&lang=js"

import "./modelo01.vue?vue&type=style&index=0&id=19eb88d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19eb88d0"]])

export default __exports__